import Spinner from '../../components/Spinner';
import React, { useState, useEffect, useRef } from 'react';
import api from '../../services/api';

const CATEGORIAS = [
  { key: 'pendientes', label: '⚠️ Pendientes' },
  { key: 'certificados', label: '📜 Certificados' },
  { key: 'lnm', label: '📗 LNM' },
  { key: 'lin', label: '🗺️ LIN' },
  { key: 'otros', label: '📁 Otros' },
];

export default function Documentacion() {
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [firmando, setFirmando] = useState(null);
  const [modalFirma, setModalFirma] = useState(null);
  const [tab, setTab] = useState('pendientes');
  const canvasRef = useRef(null);
  const dibujando = useRef(false);

  useEffect(() => { cargar(); }, []);

  const cargar = () => {
    setLoading(true);
    api.get('/documentos/mis-documentos').then(r => setDocs(r.data)).finally(() => setLoading(false));
  };

  const iniciarDibujo = (e) => {
    dibujando.current = true;
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    const x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
    const y = (e.touches ? e.touches[0].clientY : e.clientY) - rect.top;
    const ctx = canvas.getContext('2d');
    ctx.beginPath();
    ctx.moveTo(x, y);
  };

  const dibujar = (e) => {
    if (!dibujando.current) return;
    e.preventDefault();
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    const x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
    const y = (e.touches ? e.touches[0].clientY : e.clientY) - rect.top;
    const ctx = canvas.getContext('2d');
    ctx.lineWidth = 2;
    ctx.strokeStyle = '#1a1a1a';
    ctx.lineTo(x, y);
    ctx.stroke();
  };

  const finDibujo = () => { dibujando.current = false; };

  const limpiarFirma = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
  };

  const firmarAcuse = async () => {
    const id = modalFirma;
    const canvas = canvasRef.current;
    const firma = canvas.toDataURL('image/png');
    setFirmando(id);
    try {
      await api.post(`/documentos/${id}/acuse`, { firma });
      setModalFirma(null);
      cargar();
    } catch(e) {
      alert('Error al firmar el acuse');
    } finally {
      setFirmando(null);
    }
  };

  const pendientes = docs.filter(d => !d.acuse_id);
  
  const docsFiltrados = tab === 'pendientes' 
    ? pendientes
    : docs.filter(d => (d.categoria || 'otros') === tab);

  if (loading) return <Spinner />;

  return (
    <div>
      <h2 style={{ fontSize: 20, fontWeight: 600, margin: '0 0 16px' }}>Documentación</h2>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: 6, marginBottom: 16, overflowX: 'auto', paddingBottom: 4 }}>
        {CATEGORIAS.map(c => (
          <button key={c.key} onClick={() => setTab(c.key)} style={{
            padding: '8px 14px', borderRadius: 10, border: 'none', cursor: 'pointer',
            fontSize: 12, fontWeight: 500, whiteSpace: 'nowrap',
            background: tab === c.key ? '#1a1a1a' : '#fff',
            color: tab === c.key ? '#fff' : '#555',
            position: 'relative'
          }}>
            {c.label}
            {c.key === 'pendientes' && pendientes.length > 0 && (
              <span style={{ position: 'absolute', top: -4, right: -4, background: '#e24b4a', color: '#fff', borderRadius: '50%', width: 16, height: 16, fontSize: 10, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {pendientes.length}
              </span>
            )}
          </button>
        ))}
      </div>

      {/* Lista documentos */}
      {docsFiltrados.length === 0 ? (
        <div style={{ background: '#fff', borderRadius: 14, padding: 40, textAlign: 'center', color: '#aaa' }}>
          <div style={{ fontSize: 32, marginBottom: 8 }}>📄</div>
          <div>{tab === 'pendientes' ? 'Sin documentos pendientes' : 'Sin documentos en esta categoría'}</div>
        </div>
      ) : docsFiltrados.map(d => (
        <div key={d.id} style={{
          background: '#fff', borderRadius: 12, padding: 16, marginBottom: 8,
          border: !d.acuse_id ? '2px solid #fcc' : '1px solid #e5e5e5'
        }}>
          <div style={{ fontWeight: 600, fontSize: 15, marginBottom: 4 }}>
            {d.acuse_id ? '✅' : '📄'} {d.titulo}
          </div>
          {d.descripcion && <div style={{ fontSize: 12, color: '#555', marginBottom: 8 }}>{d.descripcion}</div>}
          <div style={{ fontSize: 11, color: '#888', marginBottom: 12 }}>
            {new Date(d.created_at).toLocaleDateString('es-ES')}
            {d.acuse_id && <span style={{ marginLeft: 8, color: '#16a34a' }}>· Firmado el {new Date(d.fecha_acuse).toLocaleDateString('es-ES')}</span>}
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <a href={`/api/documentos/archivo/${d.archivo}`} target="_blank" rel="noreferrer"
              style={{ flex: 1, padding: '8px', borderRadius: 8, border: '1px solid #ddd', background: '#fff', fontSize: 13, color: '#555', textDecoration: 'none', textAlign: 'center' }}>
              Ver PDF
            </a>
            {!d.acuse_id && (
              <button onClick={() => setModalFirma(d.id)} style={{
                flex: 1, padding: '8px', borderRadius: 8, border: 'none',
                background: '#1a1a1a', color: '#fff', cursor: 'pointer', fontSize: 13, fontWeight: 500
              }}>
                ✍️ Firmar
              </button>
            )}
          </div>
        </div>
      ))}

      {/* Modal firma */}
      {modalFirma && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 200, display: 'flex', alignItems: 'flex-end' }}>
          <div style={{ background: '#fff', borderRadius: '20px 20px 0 0', padding: 24, width: '100%' }}>
            <h3 style={{ margin: '0 0 8px', fontSize: 17, fontWeight: 600 }}>Firma el documento</h3>
            <p style={{ fontSize: 13, color: '#888', margin: '0 0 16px' }}>Dibuja tu firma en el recuadro</p>
            <div style={{ border: '2px solid #e5e5e5', borderRadius: 10, marginBottom: 12, background: '#fafafa', touchAction: 'none' }}>
              <canvas ref={canvasRef} width={340} height={150}
                style={{ display: 'block', width: '100%', height: 150, borderRadius: 10 }}
                onMouseDown={iniciarDibujo} onMouseMove={dibujar} onMouseUp={finDibujo} onMouseLeave={finDibujo}
                onTouchStart={iniciarDibujo} onTouchMove={dibujar} onTouchEnd={finDibujo}
              />
            </div>
            <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
              <button onClick={limpiarFirma} style={{ flex: 1, padding: '10px', borderRadius: 8, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 13 }}>
                Limpiar
              </button>
              <button onClick={firmarAcuse} disabled={firmando === modalFirma} style={{
                flex: 2, padding: '10px', borderRadius: 8, border: 'none',
                background: '#1a1a1a', color: '#fff', cursor: 'pointer', fontSize: 13, fontWeight: 500
              }}>
                {firmando === modalFirma ? 'Firmando...' : '✓ Confirmar firma'}
              </button>
            </div>
            <button onClick={() => setModalFirma(null)} style={{ width: '100%', padding: '10px', borderRadius: 8, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 13 }}>
              Cancelar
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
